(function(){
  if (window.RKProductRecommendationsReady) return;
  window.RKProductRecommendationsReady = true;

  function openCartDrawer(){
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e) {}
    try { window.dispatchEvent(new Event('cart:refresh')); } catch(e) {}
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(e) {}
    try { window.dispatchEvent(new Event('cart:open')); } catch(e) {}
    try {
      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') window.theme.cartDrawer.open();
      else if (window.T4STheme && window.T4STheme.Cart && typeof window.T4STheme.Cart.open === 'function') window.T4STheme.Cart.open();
      else if (window.T4STheme && window.T4STheme.cart && typeof window.T4STheme.cart.open === 'function') window.T4STheme.cart.open();
    } catch(e) {}
  }

  async function addToCart(form){
    var formData = new FormData(form);
    var button = form.querySelector('button[type="submit"]');
    var text = button ? button.querySelector('[data-rk-rec-btn-text]') : null;
    var original = text ? text.textContent : '';

    if (button) button.disabled = true;
    if (text) text.textContent = 'Adding…';

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error('Add to cart failed');
      if (text) text.textContent = 'Added ✓';
      openCartDrawer();
      setTimeout(function(){
        if (button) button.disabled = false;
        if (text) text.textContent = original;
      }, 1200);
    } catch(error) {
      if (text) text.textContent = 'Try again';
      setTimeout(function(){
        if (button) button.disabled = false;
        if (text) text.textContent = original;
      }, 1300);
    }
  }

  document.addEventListener('submit', function(event){
    var form = event.target.closest('[data-rk-rec-atc]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  function refreshDynamicRecommendations(root){
    root = root || document;
    var lists = root.querySelectorAll('[data-rk-product-recommendations][data-rk-dynamic-url]:not([data-rk-dynamic-loaded])');
    lists.forEach(function(list){
      var url = list.getAttribute('data-rk-dynamic-url');
      if (!url) return;
      list.setAttribute('data-rk-dynamic-loaded', 'true');
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function(response){ return response.ok ? response.text() : ''; })
        .then(function(html){
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-rk-product-recommendations]');
          if (!fresh || !fresh.children || fresh.children.length === 0) return;
          list.innerHTML = fresh.innerHTML;
        })
        .catch(function(){});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ refreshDynamicRecommendations(document); });
  } else {
    refreshDynamicRecommendations(document);
  }
  document.addEventListener('shopify:section:load', function(event){ refreshDynamicRecommendations(event.target || document); });

})();
